import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  isActive = false;
  @Input() message = 'a';
  @Input() right = '-26px';
  constructor() { }

  ngOnInit(): void {
  }

}
